module.exports = __webpack_public_path__ + "img/inventoryTrack.adccb3b5.svg";